import { useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import moment from 'moment';

import { useLanguage } from '../../../../Context/LanguageContext';
import { useTheme } from '../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../Styles/theme';

import FetchModule from '../../../Share/Network/FetchModule';

import LessonReserveHistoryDeleteModal from './Modal/LessonReserveHistoryDeleteModal';
import CourseHistoryAddModal from './Modal/CourseHistoryAddModal';

import { ReactComponent as MenuSvg } from '../../../../image/Menu.svg';

const CourseHistoryInfoView = (props) => {
  const { data, memberId, memberName, rendering } = props;
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const history = useHistory();

  const [isClicked, setIsClicked] = useState(false);
  const [state, setState] = useState('예약중');
  const [isAvailableExit, setIsAvailableExit] = useState(false);
  const [isAbsent, setIsAbsent] = useState(false);
  const [isLate, setIsLate] = useState(false);
  const [isAttendance, setIsAttendance] = useState(false);
  const [isClickedDeleteHistory, setIsClickedDeleteHistory] = useState(false);
  const [isClickedEditModal, setIsClickedEditModal] = useState(false);

  const OptionBoxRef = useRef();
  const OptionButtonRef = useRef();

  // isClicked 상태에 따라 옵션 박스 스타일 변경 //
  useEffect(() => {
    if (isClicked) {
      OptionBoxRef.current.style.height = `180px`;
      OptionBoxRef.current.style.border = `1px solid ${theme.primary}`;
    }
    else {
      OptionBoxRef.current.style.height = `0px`;
      OptionBoxRef.current.style.border = `0px solid ${theme.primary}`;
    }
  }, [isClicked])

  // 예약 상태 결정 //
  useEffect(() => {
    if (data.status === 0) {
      if (moment(data.classDate.split('T')[0] + "T" + data.classTime.split('-')[0] + ':00').isAfter(moment())) {
        setState(t('memberDetail.statusReserved'));
        setIsAvailableExit(true);
        setIsAbsent(true);
        setIsLate(true);
        setIsAttendance(true);
      }
      else {
        setState(t('memberDetail.statusAbsent'));
        setIsAvailableExit(true);
        setIsAbsent(false);
        setIsLate(true);
        setIsAttendance(true);
      }
    }
    else if (data.status === 1) {
      setState(t('memberDetail.statusAttended'));
      setIsAvailableExit(true);
      setIsAbsent(true);
      setIsLate(true);
      setIsAttendance(false);
    }
    else if (data.status === 2) {
      setState(t('memberDetail.statusLate'));
      setIsAvailableExit(true);
      setIsAbsent(true);
      setIsLate(false);
      setIsAttendance(true);
    }
    else if (data.status === 3) {
      setState(t('memberDetail.statusAbsent'));
      setIsAvailableExit(true);
      setIsAbsent(false);
      setIsLate(true);
      setIsAttendance(true);
    }
  }, [data])

  // 외부 클릭 감지 등록 //
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  function onClickOutSide(e) {
    if (OptionButtonRef.current.contains(e.target) || OptionBoxRef.current.contains(e.target)) return;
    setIsClicked(false);
  }

  function mouseOver() {
    OptionButtonRef.current.style.opacity = 1;
  }

  function mouseLeave() {
    OptionButtonRef.current.style.opacity = 0;
  }

  function onClickChangeState(state) {
    if (!isAttendance && state === 1) return;
    else if (!isLate && state === 2) return;
    else if (!isAbsent && state === 3) return;

    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.postData('reserve/modify/' + data.id + '/' + state, 'POST');

        if (responseData.status === 200)  rendering();
        else if (responseData.status === 401) history.push('/login');
      }
    )();
  }

  function onClickDeleteLessonReservation() {
    if (!isAvailableExit) return;

    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.postData('reserve/delete/manage/' + data.id, 'POST');

        if (responseData.status === 200) rendering();
        else if (responseData.status === 401) history.push('/login');
      }
    )();
  }

  return (
    <TopLevelWrapper onMouseOver={mouseOver} onMouseLeave={mouseLeave}>
      {isClickedDeleteHistory && <LessonReserveHistoryDeleteModal exitClickFn={() => setIsClickedDeleteHistory(false)} deleteClickFn={onClickDeleteLessonReservation} />}
      {isClickedEditModal && <CourseHistoryAddModal memberId={memberId} memberName={memberName} editData={data} rendering={rendering} onClickClose={() => setIsClickedEditModal(false)} />}
      <ComponentWrapper isExistLessonNote={data.lessonNote !== ''} $isDark={isDark}>
        <Table>
          <Body>
            <Tr style={{ width: '100px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '90px' }}>
                  <Text>{moment(data.classDate).format(t('memberDetail.membershipEditModal.dateFormat'))}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '200px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '190px' }}>
                  <Text>{{ '일반방문': t('memberDetail.dataGeneralVisit'), '일반 방문': t('memberDetail.dataGeneralVisit') }[data.lessonName] || data.lessonName}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '65px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '55px' }}>
                  <Text>{data.classTime.slice(0, 5)}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '100px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '90px' }}>
                  <Text>{{ '없음': t('memberDetail.dataNone') }[data.teacherName] || data.teacherName}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '177px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '167px' }}>
                  <Text>{data.memberShipName}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '100px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '90px' }}>
                  <Text>{data.deduction}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '90px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '80px' }}>
                  <Text>{state}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr>
              <Td>
                <OptionButton ref={OptionButtonRef} onClick={() => setIsClicked(!isClicked)} />
                <OptionWrapper ref={OptionBoxRef}>
                  <Option isAvailable={true} onMouseDown={() => { setIsClickedEditModal(true); setIsClicked(false); }}>{t('memberDetail.btnModifyHistory')}</Option>
                  <Option isAvailable={isAvailableExit} onMouseDown={() => setIsClickedDeleteHistory(true)}>{t('memberDetail.btnDeleteHistory')}</Option>
                  <Option isAvailable={isAttendance} onMouseDown={() => onClickChangeState(1)}>{t('memberDetail.optMarkAttended')}</Option>
                  <Option isAvailable={isLate} onMouseDown={() => onClickChangeState(2)}>{t('memberDetail.optMarkLate')}</Option>
                  <Option isAvailable={isAbsent} onMouseDown={() => onClickChangeState(3)}>{t('memberDetail.optMarkAbsent')}</Option>
                </OptionWrapper>
              </Td>
            </Tr>
          </Body>
        </Table>
      </ComponentWrapper>
      {
        data.lessonNote !== '' &&
        <LessonNoteBox>
          <PreText fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='default'>{data.lessonNote}</PreText>
        </LessonNoteBox>
      }
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;

  width: 970px;
`;

const LessonNoteBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 10px 20px;

  box-sizing: border-box;
  width: 800px;

  border-radius: 0px 0px 10px 10px;
  background-color: ${props => props.theme.buttonFill3};
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: 50px;

  background: ${props => props.theme.subBackground};

  // box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};
  border: 1px solid ${props => props.theme.subBackground};
  border-radius: ${props => props.isExistLessonNote ? `30px 30px 0px 30px` : `30px`};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
      border: 1px solid ${props => props.theme.primary};
    }
  }
`;

const Table = styled.table`
  display: flex;
  flex-direction: row;
`;

const Body = styled.tbody`
  display: flex;
  flex-direction: row;

  align-items: center;

  margin-left: 20px;

  gap: 10px;
`;

const Tr = styled.tr`
  display: flex;
  flex-direction: row;
`;

const Td = styled.td`
  display: flex;
  flex-direction: row;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  overflow: hidden;

  max-height: 20px;
`;

const Text = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
  padding: 0 0 0 0;
`;

const OptionButton = styled(MenuSvg)`
  width: 21px;
  height: auto;
  opacity: 0;

  & rect {
    fill: ${props => props.theme.line};
  }

  transition: all 0.3s ease-in-out;
`;

const OptionWrapper = styled.div`
  position: absolute;

  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  overflow: hidden;

  margin-top: 40px;
  margin-left: -30px;

  z-index: 5;

  border-radius: 8px;

  transition: all 0.2s ease-in-out;
`;

const Option = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 78px;
  height: 36px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.isAvailable ? props.theme.primary : props.theme.subText};
  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
      color: ${props => props.isAvailable ? props.theme.subBackground : props.theme.subText};
      background-color: ${props => props.isAvailable ? props.theme.primary : props.theme.subBackground};
    }
  }
`;

const PreText = styled.pre`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  padding: 0 0 0 0;

  white-space: pre-wrap;
  word-break: break-word;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;

export default CourseHistoryInfoView;
